import Icon from '../components/Icon.vue'

Icon.register({
  calculator: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 0H48C22.4 0 0 22.4 0 48V464C0 489.6 22.4 512 48 512H400C425.6 512 448 489.6 448 464V48C448 22.4 425.6 0 400 0zM128 435.2C128 441.6 121.6 448 115.2 448H76.8C70.4 448 64 441.6 64 435.2V396.8C64 390.4 70.4 384 76.8 384H115.2C121.6 384 128 390.4 128 396.8V435.2zM128 307.2C128 313.6 121.6 320 115.2 320H76.8C70.4 320 64 313.6 64 307.2V268.8C64 262.4 70.4 256 76.8 256H115.2C121.6 256 128 262.4 128 268.8V307.2zM256 435.2C256 441.6 249.6 448 243.2 448H204.8C198.4 448 192 441.6 192 435.2V396.8C192 390.4 198.4 384 204.8 384H243.2C249.6 384 256 390.4 256 396.8V435.2zM256 307.2C256 313.6 249.6 320 243.2 320H204.8C198.4 320 192 313.6 192 307.2V268.8C192 262.4 198.4 256 204.8 256H243.2C249.6 256 256 262.4 256 268.8V307.2zM384 435.2C384 441.6 377.6 448 371.2 448H332.8C326.4 448 320 441.6 320 435.2V268.8C320 262.4 326.4 256 332.8 256H371.2C377.6 256 384 262.4 384 268.8V435.2zM384 179.2C384 185.6 377.6 192 371.2 192H76.8C70.4 192 64 185.6 64 179.2V76.8C64 70.4 70.4 64 76.8 64H371.2C377.6 64 384 70.4 384 76.8V179.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calculator.js
// module id = sdYY
// module chunks = 144